import { TITLE, TEXT, BUTTONS, REWARD } from '../../../../components/modals/universalModal'
import { CHALLENGES } from '../../../../constants/shared/states/names'

export function convertorModalsContent({ customCallbacks }) {
  return {
    type: 'universalModal',
    props: {
      modalProps: {
        wrapper: { isFullPage: false },
        modifier: ['noFullNoScroll'],
      },
      components: [
        {
          list: [
            {
              type: TITLE,
              props: {
                modifier: 'padding-no',
                value: 'giftConverterRulesContent.title',
              },
            },
            {
              type: TEXT,
              props: {
                modifier: 'list',
                noMin: true,
                value: 'giftConverterRulesContent.description',
              },
            },
            {
              type: BUTTONS,
              props: {
                buttons: [
                  {
                    text: 'other.toChallenges',
                    disposable: true,
                    callbackKey: 'setState',
                    callbackOptions: CHALLENGES,
                    customCallbacks,
                    modalData: {
                      action: 'close',
                      data: { type: 'all' },
                    },
                  },
                  {
                    text: 'other.backToGame',
                    className: 'custom-button_gray',
                    customCallbacks,
                    disposable: true,
                    modalData: {
                      action: 'close',
                      data: { type: 'current' },
                    },
                  },
                ],
              },
            },
          ],
        },
      ],
    },
  }
}

export function convertResult({
  proportion,
  rewardValue,
  giftsRemain,
  customCallbacks,
  isCanContinue,
  t,
}) {
  return {
    type: 'universalModal',
    props: {
      modalProps: {
        wrapper: { isFullPage: false },
        modifier: ['noFullNoScroll'],
      },
      components: [
        {
          list: [
            {
              type: REWARD,
              props: {
                type: 'bonusesFire',
                mod: 'universal-middle',
                value: rewardValue,
              },
            },
            {
              type: TITLE,
              props: {
                modifier: 'padding-no',
                value: 'giftConverterResultContent.title',
              },
            },
            {
              type: TEXT,
              props: {
                noMin: true,
                modifier: 'minMargin',
                value: t(
                  !isCanContinue
                    ? 'giftConverterResultContent.description.notAvailable'
                    : 'giftConverterResultContent.description.isAvailable',
                  { value: proportion },
                ),
              },
            },
            {
              type: TEXT,
              props: {
                modifier: ['middle', 'middleMargin'],
                noMin: true,
                value: t('giftConverterResultContent.text', { value: giftsRemain }),
              },
            },
            {
              type: BUTTONS,
              props: {
                buttons: [
                  !isCanContinue
                    ? {
                        text: 'other.toChallenges',
                        disposable: true,
                        callbackKey: 'setState',
                        callbackOptions: CHALLENGES,
                        customCallbacks,
                        modalData: {
                          action: 'close',
                          data: { type: 'all' },
                        },
                      }
                    : {
                        text: 'other.exchangeMore',
                        disposable: true,
                        customCallbacks,
                        modalData: {
                          action: ['close', 'open'],
                          data: {
                            close: {
                              type: 'all',
                            },
                            open: {
                              type: 'converterToCoinsModal',
                            },
                          },
                        },
                      },
                  {
                    text: 'other.backToGame',
                    className: 'custom-button_gray',
                    customCallbacks,
                    disposable: true,
                    modalData: {
                      action: 'close',
                      data: { type: 'current' },
                    },
                  },
                ],
              },
            },
          ],
        },
      ],
    },
  }
}
